<div
  class="fw-bold bg-white p-3 rounded-5 mb-5 shadow"
  
>
  <!-- Primera fila -->
  <div class="d-flex justify-content-between">
    <div>
      <label for="information" class="labelInformation">{{
        information
      }}</label>
    </div>
    <div class="col btn-back text-end">
      <a class="btn btn-secondary"  (click)="goBack()">Back</a>
    </div>
  </div>

  <app-device-form [iccid]="devceID" [attr.isAdmin]="true" (handleCreateUpdateResponse)="handleCreateUpdateResponse($event)"></app-device-form>


</div>

